// Ensure ThreeJS is in global scope for the 'examples/'
global.THREE = require("three");
const glslify = require('glslify');

global.np = require("npyjs");

import npyjs from "npyjs";

const n = new npyjs();


let W1 = n.load("W1.npy", (array) => {
  const weights = [];
  for (let x = 0; x < array.shape[0]; x++){
    weights[x] = new THREE.Vector3(array.data[x], array.data[500 + x], array.data[1000 + x]); 
  }
  // textweights[3] = 1.0;
  return weights;
});


let W2 = n.load("W2.npy", (array)=> {
  const weights = [];
  for (let x = 0; x < array.shape[1]; x++){
    weights[x] = array.data[x];
  }
  return weights;
});

let B1 = n.load("B1.npy", (array)=> {
  const weights = [];
  for (let x = 0; x < array.shape[0]; x++){
    weights[x] = array.data[x];
  }
  return weights;
});

let B2 = n.load("B2.npy", (array)=> {
  const weights = array.data[0]
  return weights;
});

let yrange = n.load("yrange.npy", (array)=> {
  const weights = array.data[0]
  return weights;
});

// Include any additional ThreeJS examples below
require("three/examples/js/controls/OrbitControls");

const canvasSketch = require("canvas-sketch");

const settings = {
  // Make the loop animated
  animate: true ,
  // Get a WebGL canvas rather than 2D
  context: "webgl"
};

Promise.all([W1, W2, B1, B2, yrange]).then((array) => {

  

  W1 = array[0];
  W2 = array[1];
  B1 = array[2];
  B2 = array[3];
  yrange = array[4];

  console.log(W1);
  console.log(W2);
  console.log(B1);
  console.log(B2);
  console.log(yrange);


  let data = [];
  W1.forEach(w => {data.push(w.x, w.y, w.z, 1.0)});

  let dataArray = new Float32Array(data);

  const tex = new THREE.DataTexture( dataArray, 500, 1 , THREE.RGBAFormat, THREE.FloatType);
  tex.needsUpdate = true;
  tex.magFilter = THREE.NearestFilter;

  console.log(tex);

  const sketch = ({ context }) => {
    // Create a renderer
    const renderer = new THREE.WebGLRenderer({
      canvas: context.canvas
    });
  
    // WebGL background color
    renderer.setClearColor("#000", 1);
  
    // Setup a camera
    const camera = new THREE.PerspectiveCamera(50, 1, 0.01, 100);
    camera.position.set(-4, 0, 0);
    camera.up = new THREE.Vector3(0,0,1);
    camera.lookAt(new THREE.Vector3());
  
    // Setup camera controller
    const controls = new THREE.OrbitControls(camera, context.canvas);
  
    // Setup your scene
    const scene = new THREE.Scene();
  
    // Setup a geometry
    const geometry = new THREE.BoxGeometry(2,2,2);
    
  
    const vertexShader = `
    varying vec3 pos;
  
    void main () {
      pos = position;
      gl_Position  = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `;
  
  const fragmentShader = glslify(`
    #pragma glslify: intersectBounds = require('./shader_intersection.glsl');
    varying vec3 pos;
    uniform vec3 color1;
    uniform vec3 color2;
    uniform vec3 cameraPos;

    uniform sampler2D W1;
    uniform highp float W2[500];
    uniform highp float B1[500];
    uniform highp float B2;
    uniform highp float yrange;
  
    mat2 S = mat2(-1.0, 0.0, -1.0, -1.0);

    vec2 w3 = vec2(-1.0, 1.0);
    mat3 rot;

    void main () {
      vec3 dir = normalize(pos - cameraPos);
      vec2 tvals = intersectBounds(cameraPos, dir);
      float dist = (tvals[1]-tvals[0]);

      mat3 correcter = mat3(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, -1.0, 0.0);

      S[0][0] = -dist;

      if (dir[0] != -1.0){
        mat3 skew = mat3(0.0, dir[1], dir[2], -dir[1], 0.0, 0.0, -dir[2], 0.0, 0.0);
        rot = mat3(1.0,0.0,0.0,0.0,1.0,0,0.0,0.0,1.0) + skew + (skew * skew)/(1.0+dir[0]);
      } else {
        rot = mat3(-1.0, 0.0, 0.0, 0.0, -1.0, 0.0, 0.0, 0.0, 1.0);
      }
      
      float acc = 0.0 + B2*dist;
      float step = 1.0 / 500.0;
      float halfstep = 0.5 * step;
       for (int i = 0; i < 500; i++){
         vec4 pixel = texture2D(W1, vec2(float(i)*step+halfstep,0.5));
         vec3 transformedW1 = pixel.rgb*rot;
         vec2 yi = vec2(transformedW1.x, B1[i] + dot(pixel.rgb, pos));
         vec2 yp = S*yi;
         float qi = dot(w3, vec2(-log(1.0+exp(yp[0])),-log(1.0+exp(yp[1]))));
         float vi = dist + qi/transformedW1.x;
         acc += vi*W2[i];
       }

       acc += dist;
       acc /= yrange;
  
      gl_FragColor = vec4(mix(color2,color1, acc), 1.0);//temp;//texture2D(W1, vec2(0.0*step + halfstep,0.5));//vec4(texelFetch(W1, ivec2(0,0),0).rgb, 1.0);
    }
  `);

  const material = new THREE.ShaderMaterial({
    vertexShader,
    fragmentShader,
    uniforms: {
      cameraPos: {value: camera.position},
      color1: { value: new THREE.Color('white') },
      color2: { value: new THREE.Color('black') },
      W1: { value: tex },
      W2: { value: W2 },
      B1: { value: B1 },
      B2: { value: B2 },
      yrange: { value: yrange }
    }
  });
  
    // Setup a mesh with geometry + material
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(0, 0, 0);
    scene.add(mesh);
  
    // draw each frame
    return {
      // Handle resize events here
      resize({ pixelRatio, viewportWidth, viewportHeight }) {
        renderer.setPixelRatio(pixelRatio);
        renderer.setSize(viewportWidth, viewportHeight, false);
        camera.aspect = viewportWidth / viewportHeight;
        camera.updateProjectionMatrix();
      },
      // Update & render your scene here
      render({ time }) {
        controls.update();
        renderer.render(scene, camera);
      },
      // Dispose of events & renderer for cleaner hot-reloading
      unload() {
        controls.dispose();
        renderer.dispose();
      }
    };
  };
  
  return canvasSketch(sketch, settings);

})
